<!-- MFITTの予約取り消し完了完了ダイアログ -->
<template>
  <ItemDialog ref="cancelCompleted" image-type="done">
    <template #content-area>
      <h2>予約取り消しが完了しました</h2>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCancelCompleted",
  props: {
    closeButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const cancelCompleted = ref(null);

    const openDialog = () => {
      cancelCompleted.value.open();
    };

    const closeDialog = () => {
      if (props.closeButtonClicked == null) {
        cancelCompleted.value.close();
      } else {
        props.closeButtonClicked();
      }
    };

    return {
      cancelCompleted,
      openDialog,
      closeDialog,
    };
  },
};
</script>
